enum TagType {
    PRIMARY,
    SECONDARY,
    DEFAULT,
    DANGER
}

export default TagType;